export default "__VITE_ASSET__5eb66575__"